// extracted by mini-css-extract-plugin
var _1 = "GeBO3tArdee07H75y3x6";
var _2 = "m6s4PhPJHdbGAh_zOrwZ";
export { _1 as "loadingText", _2 as "spin" }
